import { cn } from '@/lib/utils';

interface TabItem {
	value: string;
	label: string;
	count?: number;
}

interface TabsProps {
	value: string;
	onChange: (value: string) => void;
	items: TabItem[];
}

export function Tabs({ value, onChange, items }: TabsProps) {
	return (
		<div className="flex gap-0 border-b border-line-1">
			{items.map((item, i) => (
				<button
					key={item.value}
					onClick={() => onChange(item.value)}
					className={cn(
						'relative px-4 pb-2.5 pt-1 text-base font-medium transition-colors duration-[120ms]',
						i === 0 && 'pl-0',
						value === item.value ? 'text-text-1' : 'text-text-3 hover:text-text-2'
					)}
				>
					<span className="flex items-center gap-1.5">
						{item.label}
						{item.count !== undefined && (
							<span
								className={cn(
									'rounded-full px-1.5 py-px font-mono text-2xs',
									value === item.value
										? 'bg-accent-soft text-accent'
										: 'bg-surface-fill text-text-4'
								)}
							>
								{item.count}
							</span>
						)}
					</span>
					{value === item.value && (
						<span
							className={cn(
								'absolute bottom-0 right-4 h-[1.5px] rounded-full bg-accent',
								i === 0 ? 'left-0' : 'left-4'
							)}
						/>
					)}
				</button>
			))}
		</div>
	);
}
